<template>
  <div>
    <div class="purchase-type">
      <!--
      <div v-show="balance - amount < 0">
        <div class="tips">Insufficient balance! The remaining ${{ amount - balance }} can be paid in other ways.</div>
      </div>
      -->
      <el-form label-position="left">
        <el-form-item v-if="canUseBalance == true">
          <div class="alert-text">
            <div class="left"></div>
            <div class="checked">
              <el-checkbox v-model="useBalance" :disabled="amount == 0 || (balance - amount) < 0 ? true : false"/>
              <span>{{ $t('common.payComp.balance') }}</span>
              <p>{{ $store.state.currency }} {{ $util.convertCurrency(balance) }}</p>
            </div>
          </div>
        </el-form-item>
        <el-form-item :label="$t('common.payComp.methods.header')" label-width="150px" v-show="amount > 0 && (canUseBalance == 0 || useBalance == false)">
          <ul>
            <template v-if="canUseCard == 1">
              <li :class="{ 'pay-active': selectedCard === 1 }" @click="selectedCard = 1,payCode=''">
                <el-popover placement="top" trigger="click" v-model="cardPopover">
                  <div class="payment-list">
                    <div class="payment-item" :class="{'active-payment': payCode == item.cardName}" v-for="(item, index) in cardList" :key="index"
                         @click="selectCard(item)">
                      <div class="imgbox" v-if="item.cardName == 'visa'">
                        <svg class="icon" aria-hidden="true">
                          <use xlink:href="#icon-Pay_Visa"></use>
                        </svg>
                      </div>
                      <div class="imgbox" v-if="item.cardName == 'mastercard'">
                        <svg class="icon" aria-hidden="true">
                          <use xlink:href="#icon-Pay_Mastercard"></use>
                        </svg>
                      </div>
                      <div class="imgbox" v-if="item.cardName == 'express'">
                        <svg class="icon" aria-hidden="true">
                          <use xlink:href="#icon-Pay_Express"></use>
                        </svg>
                      </div>
                      <div class="imgbox" v-if="item.cardName == 'unionPay'">
                        <svg class="icon" aria-hidden="true">
                          <use xlink:href="#icon-Pay_UnionPay"></use>
                        </svg>
                      </div>
                      <ul class="payment-card">
                        <li>{{ item.cardName }}</li>
                        <li>{{ item.cardNumber }}</li>
                        <li>{{ $t('common.payComp.expires') }}</li>
                        <li>06/26</li>
                        <li class="orange" v-if="index == 1">{{ $t('common.payComp.default') }}</li>
                        <li class="orange" v-else>{{ $t('common.payComp.expiresSoon') }}</li>
                      </ul>
                    </div>
                  </div>
                  <div slot="reference">
                    <div class="iconbox">
                      <p v-if=" payCode == 'visa' || selectedCard == 0 || (cardId == 0 && selectedCard == 1)">
                        <svg class="icon" aria-hidden="true">
                          <use xlink:href="#icon-Pay_Visa"></use>
                        </svg>
                      </p>
                      <p v-if="payCode == 'mastercard' || selectedCard == 0 || (cardId == 0 && selectedCard == 1)">
                        <svg class="icon" aria-hidden="true">
                          <use xlink:href="#icon-Pay_Mastercard"></use>
                        </svg>
                      </p>
                      <p v-if="payCode == 'express' || selectedCard == 0 || (cardId == 0 && selectedCard == 1)">
                        <svg class="icon" aria-hidden="true">
                          <use xlink:href="#icon-Pay_Express"></use>
                        </svg>
                      </p>
                      <p v-if=" payCode == 'unionPay' || selectedCard == 0 || (cardId == 0 && selectedCard == 1)">
                        <svg class="icon" aria-hidden="true">
                          <use xlink:href="#icon-Pay_UnionPay"></use>
                        </svg>
                      </p>
                    </div>
                    <p>{{ $t('common.payComp.methods.creditCard') }}</p>
                  </div>
                </el-popover>
              </li>
            </template>
            <template v-for="payment in payments">
              <li :class="{ 'pay-active': payCode === payment.pay_code }" @click="selectPayment(payment)">
                <div class="iconbox">
                  <p>
                    <svg class="icon" aria-hidden="true">
                      <use :xlink:href="payment.icon"></use>
                    </svg>
                  </p>
                </div>
                <p>{{ payment.pay_name }}</p>
              </li>
            </template>
          </ul>
          <el-button type="primary" class="addBtn" @click="goto" v-if="canUseCard == 1">{{ $t('common.payComp.addPaymentMethod') }}</el-button>
        </el-form-item>
        <el-form-item :label="$t('common.payComp.password.header')" label-width="150px" v-show="canUseBalance == 1 && useBalance == true">
          <el-input v-model="extend.password" :type="inputType" class="pwd-input" :placeholder="$t('common.payComp.password.placeholder')">
            <span slot="suffix" autocomplete="auto" @click="flag = !flag">
              <svg class="view-icon" aria-hidden="true" v-show="flag == false">
                <use xlink:href="#icon-yanjing_xianshi_o"></use>
              </svg>
              <svg class="view-icon" aria-hidden="true" v-show="flag == true">
                <use xlink:href="#icon-yanjing_yincang_o"></use>
              </svg>
            </span>
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <form :id="form_id" method="get" :action="payUrl+'/pay/index'" target="_blank">
      <input type="hidden" name="sn" v-model="orderSn"/>
      <input type="hidden" name="pay_code" v-model="payCode"/>
      <input type="hidden" name="order_code" value="Orders"/>
      <input type="hidden" name="platform" value="pc"/>
    </form>
  </div>
</template>
<script>
export default {
  data() {
    return {
      that: this,
      orderSn: '',
      payUrl: '',
      useBalance: true,
      selectedCard: 1,
      payCode: 'balance',
      cardId: '',
      cardList: [
        {
          id: 1,
          cardName: 'visa',
          displayName: 'VISA',
          cardNumber: '532 748 326 7238 842',
          callPayApiMethod: 'api',
        },
        {
          id: 2,
          cardName: 'mastercard',
          displayName: 'MasterCard',
          cardNumber: '532 748 326 7238 842',
          callPayApiMethod: 'api',
        },
        {
          id: 3,
          cardName: 'express',
          displayName: 'American Express',
          cardNumber: '532 748 326 7238 842',
          callPayApiMethod: 'api',
        },
        {
          id: 4,
          cardName: 'unionPay',
          displayName: 'UnionPay',
          cardNumber: '532 748 326 7238 842',
          callPayApiMethod: 'api',
        },
      ],
      cardPopover: false, //卡列表选择
      callPayApiMethod: 'api',
      amount: 0.00,
      balance: 0.00,
      extend: {
        password: '',
      },
      flag: true, //密码实现隐藏
      inputType: 'password',
      form_id: '',
      payments: [],//交易渠道列表
      canUseBalance: 1,
      canUseCard: 0,
      defaultPayment: {},
      needPay: 1,
    };
  },
  created() {
    this.form_id = 'payFrom-' + this.randomString(32);
    this.payUrl = process.env.YISU_API_URL;
  },
  mounted() {
    this.getPayments()
  },
  watch: {
    flag: {
      handler(n, o) {
        if (n) {
          this.inputType = "password";
        } else {
          this.inputType = "text";
        }
      },
    },
    amount: {
      handler(n, o) {
        if(this.needPay == 1) {
          if (this.balance > 0) {
            if ((this.balance >= parseFloat(this.amount)) && this.canUseBalance) {
              this.payCode = 'balance';
              this.callPayApiMethod = 'api'
              this.selectedCard = 0;
              this.cardId = 0;
              this.useBalance = true;
            } else {
              this.useBalance = false;
              this.selectPayment(this.defaultPayment);
              this.selectedCard = 1;
            }
          }
        }
      },
    },
    needPay: {
      handler(n, o) {
          if(n == 0) {
            this.payCode = 'balance';
            this.callPayApiMethod = 'api'
            this.selectedCard = 0;
            this.cardId = 0;
            this.useBalance = true;
            this.$emit(
              "setPayCode",
              this.payCode,
              this.cardId,
              this.callPayApiMethod
            );
          }
      },
    },
    useBalance: {
      handler(n, o) {
        this.payCode = '';
        if (n == true) {
          this.payCode = 'balance';
          this.callPayApiMethod = 'api'
          this.selectedCard = 0;
          this.cardId = 0;
        } else {
          this.selectPayment(this.defaultPayment);
          this.selectedCard = 1;
        }
        this.$emit(
          "setPayCode",
          this.payCode,
          this.cardId,
          this.callPayApiMethod
        );
      },
    }
  },

  computed: {
    upperCase() {
      if (this.payCode) {
        return (
          this.payCode.substring(0, 1).toUpperCase() + this.payCode.substring(1)
        );
      } else {
        return this.payCode;
      }
    },
  },
  methods: {
    async getPayments() {
      let {data: {code, message, data}} = await this.$http.get('/general/payments/lists', {type: 'Orders'})
      if (code !== 0) {
        this.$message.error(message)
        return false
      }
      this.payments = data.channel;
      this.canUseBalance = data.useBalance;
      this.canUseCard = data.useCard;
      this.balance = parseFloat(data.balance);
      if(this.needPay == 1) {
        if (this.balance == 0 || this.balance<this.amount) {
          this.useBalance = false;
        }
      }
      if (this.canUseCard == 0) {
        this.defaultPayment = data.defaultPayment;
        if (parseFloat(this.amount) > this.balance) {
          this.selectPayment(this.defaultPayment);
        }
      }
    },
    selectPayment(payment) {
      this.payCode = payment.pay_code;
      this.selectedCard = 0;
      this.cardId = 0;
      this.callPayApiMethod = payment.submit_method;
      this.$emit(
        "setPayCode",
        this.payCode,
        this.cardId,
        this.callPayApiMethod
      );
    },
    selectCard(e) {
      this.payCode = e.cardName;
      this.cardId = e.id;
      this.cardPopover = false;
      this.callPayApiMethod = e.callPayApiMethod;
      this.$emit(
        "setPayCode",
        this.payCode,
        this.cardId,
        this.callPayApiMethod
      );
    },
    goto() {
      this.$router.push({
        path: "/billing/index",
      });
    },
    //生成随机字符串
    randomString(length) {
      var str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
      var result = '';
      for (var i = length; i > 0; --i)
        result += str[Math.floor(Math.random() * str.length)];
      return result;
    }
  },
};
</script>
<style scoped lang="scss">
.purchase-type {
  ul {
    flex: 1;
    display: grid;
    grid-gap: 20px;
    grid-template-columns: repeat(3, 160px);

    li {
      width: 160px;
      height: 90px;
      border: 1px solid #dbe1e8;
      cursor: pointer;

      .iconbox {
        display: flex;
        margin: 0 auto 12px;
        padding: 24px 20px 0;

        p {
          flex: 1;
          height: 16px;

          .icon {
            height: 16px;
            width: 100%;
            font-size: 30px;
            vertical-align: top;
          }
        }
      }

      .payicon-list {
        padding: 0 24px;
      }

      p {
        color: #0f1e33;
        font-size: 14px;
        line-height: 28px;
        text-align: center;
        font-weight: bold;
      }

      &:last-child {
        margin-right: 0;
      }

      &:hover {
        box-shadow: 0px 2px 6px 0px rgba(31, 37, 51, 0.16);
      }

      &.pay-active {
        border-color: #3377ff;
        box-shadow: 0px 2px 6px 0px rgba(31, 37, 51, 0.16);
      }
    }
  }
}

.tips {
  font-size: 12px;
  margin-bottom: 24px;
}

.payment-list {
  max-height: 400px;
  overflow: auto;

  .payment-item {
    font-size: 16px;
    border: 1px solid #dbe1e8;
    padding: 10px 24px;
    margin-bottom: 12px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    cursor: pointer;

    .imgbox {
      width: 60px;
      height: 30px;
      text-align: center;
      margin-right: 20px;

      .icon {
        display: inline-block;
        width: 60px;
        height: 30px;
      }
    }

    .payment-card {
      height: 50px;
      display: flex;
      align-items: center;

      li {
        color: #0f1e33;
        font-size: 14px;
        margin-right: 20px;

        &:first-child {
          width: 90px;
        }
      }

      .orange {
        color: #f7ba2a;
      }
    }
  }

  .active-payment {
    border-color: #3377ff;
    box-shadow: 0px 2px 6px 0px rgba(31, 37, 51, 0.16);
  }

  .payment-item:hover {
    box-shadow: 0px 2px 6px 0px rgba(31, 37, 51, 0.16);
  }
}

.addBtn {
  margin-top: 24px;
}

.password-wrap {
  padding-left: 150px;
  position: relative;

  > p {
    position: absolute;
    left: 0;
    line-height: 40px;
  }
}

.view-icon {
  width: 16px;
  height: 16px;
  margin-top: 12px;
  font-size: 16px;
  cursor: pointer;
  padding-right: 10px;
}

.alert-text {
  height: 48px;
  padding: 0 24px 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    color: #5e6d81;
    line-height: 48px;
    padding: 0 14px 0 12px;
  }

  p {
    color: #0f1e33;
    line-height: 48px;
  }

  .left span {
    padding-left: 0;
  }

  .left,
  .checked {
    display: flex;
    align-items: center;
  }
}

.el-form-item {
  margin-bottom: 22px;
}
</style>
<style>
.el-form--label-left .el-form-item__label {
  float: left !important;
}
</style>



// WEBPACK FOOTER //
// src/components/paySelect/PaymentMethod.vue